import {
  Icons,
  HexIcon,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { getDocsLink } from '@cast/utils';

export const NoNativeHpaEmptyState = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      py={16}
      px={36}
      position="relative"
      flexGrow={1}
      data-testid="no-native-hpa-empty-state"
    >
      <HexIcon variant="notification" icon={<Icons.Lock />} size={54} />
      <Typography variant="h6" mt={12}>
        No native HPA Found
      </Typography>
      <Typography variant="P12M" mt={8}>
        Configure Kubernetes Horizontal Pod Autoscaler for workloads that
        support multiple replicas.
      </Typography>
      <Typography variant="P12R" color={tokens.theme.fg.structural.secondary}>
        Learn how to{' '}
        <ExternalLink link={getDocsLink('docs_woop_hpa')} noIcon>
          configure native Kubernetes HPA.
        </ExternalLink>
      </Typography>
    </Stack>
  );
};
